// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Join table: which users receive which notifications.
 * Uses composite PK (notification_id, user_id) in `PostgreSQL`.
 */
export class NotificationUser implements flatbuffers.IUnpackableObject<NotificationUserT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NotificationUser {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNotificationUser(
    bb: flatbuffers.ByteBuffer,
    obj?: NotificationUser,
  ): NotificationUser {
    return (obj || new NotificationUser()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNotificationUser(
    bb: flatbuffers.ByteBuffer,
    obj?: NotificationUser,
  ): NotificationUser {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NotificationUser()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  notificationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  userId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  lastTriggered(): string | null;
  lastTriggered(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastTriggered(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  muted(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startNotificationUser(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addNotificationId(builder: flatbuffers.Builder, notificationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, notificationIdOffset, 0);
  }

  static addUserId(builder: flatbuffers.Builder, userIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, userIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addLastTriggered(builder: flatbuffers.Builder, lastTriggeredOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, lastTriggeredOffset, 0);
  }

  static addMuted(builder: flatbuffers.Builder, muted: boolean) {
    builder.addFieldInt8(4, +muted, +false);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, updatedAtOffset, 0);
  }

  static endNotificationUser(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // notification_id
    builder.requiredField(offset, 6); // user_id
    builder.requiredField(offset, 8); // organization_id
    return offset;
  }

  unpack(): NotificationUserT {
    return new NotificationUserT(
      this.notificationId() !== null ? this.notificationId()!.unpack() : null,
      this.userId() !== null ? this.userId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.lastTriggered(),
      this.muted(),
      this.createdAt(),
      this.updatedAt(),
    );
  }

  unpackTo(_o: NotificationUserT): void {
    _o.notificationId = this.notificationId() !== null ? this.notificationId()!.unpack() : null;
    _o.userId = this.userId() !== null ? this.userId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.lastTriggered = this.lastTriggered();
    _o.muted = this.muted();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
  }

  unpackFields(...fields: string[]): NotificationUserT {
    const t = new NotificationUserT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("notification_id")) {
      t.notificationId = this.notificationId() !== null ? this.notificationId()!.unpack() : null;
    }
    if (fieldSet.has("user_id")) {
      t.userId = this.userId() !== null ? this.userId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("last_triggered")) {
      t.lastTriggered = this.lastTriggered();
    }
    if (fieldSet.has("muted")) {
      t.muted = this.muted();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    return t;
  }
}

export class NotificationUserT implements flatbuffers.IGeneratedObject {
  constructor(
    public notificationId: UuidT | null = null,
    public userId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public lastTriggered: string | Uint8Array | null = null,
    public muted: boolean = false,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.notificationId === null || this.notificationId === undefined) {
      throw new Error('Required field "notification_id" is not set');
    }
    if (this.userId === null || this.userId === undefined) {
      throw new Error('Required field "user_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    const notificationId = this.notificationId !== null ? this.notificationId!.pack(builder) : 0;
    const userId = this.userId !== null ? this.userId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const lastTriggered =
      this.lastTriggered !== null ? builder.createString(this.lastTriggered!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    NotificationUser.startNotificationUser(builder);
    NotificationUser.addNotificationId(builder, notificationId);
    NotificationUser.addUserId(builder, userId);
    NotificationUser.addOrganizationId(builder, organizationId);
    NotificationUser.addLastTriggered(builder, lastTriggered);
    NotificationUser.addMuted(builder, this.muted);
    NotificationUser.addCreatedAt(builder, createdAt);
    NotificationUser.addUpdatedAt(builder, updatedAt);

    return NotificationUser.endNotificationUser(builder);
  }

  clone(): NotificationUserT {
    const obj = new NotificationUserT();
    obj.notificationId = this.notificationId !== null ? this.notificationId!.clone() : null;
    obj.userId = this.userId !== null ? this.userId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.lastTriggered = this.lastTriggered;
    obj.muted = this.muted;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    return obj;
  }

  equals(other: NotificationUserT): boolean {
    if (this.notificationId !== null && other.notificationId !== null) {
      if (!this.notificationId!.equals(other.notificationId!)) return false;
    } else if (this.notificationId !== other.notificationId) return false;
    if (this.userId !== null && other.userId !== null) {
      if (!this.userId!.equals(other.userId!)) return false;
    } else if (this.userId !== other.userId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.lastTriggered !== other.lastTriggered) return false;
    if (this.muted !== other.muted) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    return true;
  }
}

export function verifyNotificationUser(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "notification_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "user_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
